export const sharedStringsEn = {
  /**
   *
   * Shared Strings
   *
   */
  qaReview: {
    coveredProjects: "Covered projects",
    needsReview: "Needs review",
    reviewed: "Reviewed",
    structures: "Structures",
  },
  msaResignBanner: {
    due: "Sign the new Master Services Agreement by {date} to keep getting new work orders.",
    overdue: "New work orders are paused until you sign the new Master Services Agreement. Your open jobs continue.",
    action: "Review and sign",
  },
  auth: {
    error_messages: {
      form_code_incorrect: "Invalid code",
      form_password_length_too_short: "Password is too short",
      form_password_pwned: "That password has appeared in a data breach. Choose a different one.",
      form_password_not_strong_enough: "That password is too easy to guess.",
      form_password_validation_failed: "That password does not meet the requirements.",
      form_password_incorrect: "Invalid email or password",
      form_conditional_param_missing: "Invalid email address",
      session_exists: "You're already logged in",
      user_locked: "Too many attempts. Please try again in 59 minutes.",
      user_banned: "Your account has been deactivated. Please contact support.",
      form_param_format_invalid: "Invalid email address",
      form_identifier_not_found: "Invalid email or password",
      verification_not_sent: "Verification email not sent",
      form_identifier_exists: "Phone number already in use",
      verification_expired: "That code expired. Request a fresh one and try again.",
      verification_failed: "Too many attempts. Try a different method or sign in again.",
      not_allowed_access: "This verification method isn't enabled. Contact support.",
      generic_error: "Something went wrong. Please try again.",
    },
    mfa: {
      lastFactorGuard: "This is your only verification method. Add another method before removing it.",
      lastFactorGuardDescription: "You need at least one authenticator app or phone number for two-step verification.",
      factorLabel: {
        totp: "Authenticator app",
        phoneCode: "Text message",
        backupCode: "Backup code",
      },
      backupCodes: {
        title: "Backup codes",
        description: "Use backup codes to sign in if you lose access to your authenticator app or phone.",
        generate: "Generate backup codes",
        regenerate: "Regenerate codes",
        download: "Download codes",
        regenerateConfirmTitle: "Regenerate backup codes?",
        regenerateConfirmBody:
          "Your existing backup codes will stop working immediately. You'll get a new set of codes to save.",
        codesReady: "Save these codes in a secure location. Each code can only be used once.",
        codesReadyRegenerated: "New codes generated. Your previous codes no longer work.",
        downloadFileHeader: "Remi Backup Codes",
        downloadFileNote: "Each code can only be used once.",
      },
      challengeBackupCode: {
        title: "Enter a backup code",
        description: "Enter one of your backup codes to verify your identity.",
        placeholder: "Backup code",
        submit: "Verify",
      },
      setup: {
        title: "Two-step verification required",
        enrolledDescription:
          "Your account has two-step verification enabled but your current session has not been verified. Please sign out and sign back in to complete verification.",
        unenrolledDescription:
          "Your account requires two-step verification. Set up an authenticator app or text message verification below to continue.",
        signOut: "Sign out",
      },
      enrollmentBanner: {
        hasCredentials: {
          title: "Set up two-step verification",
          description: "Protect your account by adding an authenticator app or text message verification.",
          action: "Set up 2FA",
          dismiss: "Snooze",
        },
        needsCredentials: {
          title: "Set up two-step verification",
          description:
            "You'll need to add an email and password to your account before you can enable two-step verification.",
          action: "Set up 2FA",
          dismiss: "Snooze",
        },
      },
    },
  },
} as const;
